"use client";
import { useEffect, useState } from "react";
import Sidebar from "../components/SidebarUpdate";
import apiInstance from "../apiConfig/apiinstance";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";

export default function TagList() {
  const navigate = useNavigate();
  const [tagList, setTagList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchTagList = async () => {
      setLoading(true);
      try {
        const { data } = await apiInstance.get("/api/style/v1/tags/list/all/");
        if (data.status === 200 && Array.isArray(data.data)) {
          setTagList(data.data.map((tag) => tag.name));
        }
      } catch (error) {
        console.log("Error fetching tag list", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTagList();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <ClipLoader color="#3498db" loading={loading} size={50} />
        <span className="ml-3 text-gray-600">Logging in...</span>
      </div>
    );
  }

  return (
    <div className="content_wrapper">
      <Sidebar logo="FP ONE" mainLoading={loading} currentPage={currentPage} />

      <div
        style={{ overflowX: "hidden", width: "100%" }}
        className="md:ml-[18rem] mt-[5rem] md:mt-0"
      >
        <div className="p-6">
          <h2 className="text-5xl font-medium mb-4 text-left sm:text-center">
            Tags
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {tagList.map((tag, index) => (
              <div
                key={index}
                onClick={()=> navigate(`/tag/${tag}?view=apparel`)}
                className="rounded-lg py-16 text-center text-4xl cursor-pointer"
              >
                #{tag}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
